/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Pack, PackInterface } from "../Pack";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
      {
        internalType: "address",
        name: "_vrfCoordinator",
        type: "address",
      },
      {
        internalType: "address",
        name: "_linkToken",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_keyHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_fees",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "NewOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "packId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "rewardContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "packTotalSupply",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "creator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "openStart",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Pack.PackState",
        name: "packState",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "source",
            type: "address",
          },
          {
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "amountsPacked",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "rewardsPerOpen",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Pack.Rewards",
        name: "rewards",
        type: "tuple",
      },
    ],
    name: "PackCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "packId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "opener",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "rewardContract",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "rewardIds",
        type: "uint256[]",
      },
    ],
    name: "PackOpenFulfilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "packId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "opener",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
    ],
    name: "PackOpenRequest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "royaltyBps",
        type: "uint256",
      },
    ],
    name: "RoyaltyUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "TransfersRestricted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_packId",
        type: "uint256",
      },
    ],
    name: "creator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "currentRequestId",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_packId",
        type: "uint256",
      },
    ],
    name: "getPack",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "creator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "openStart",
            type: "uint256",
          },
        ],
        internalType: "struct Pack.PackState",
        name: "pack",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_packId",
        type: "uint256",
      },
    ],
    name: "getPackWithRewards",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "creator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "openStart",
            type: "uint256",
          },
        ],
        internalType: "struct Pack.PackState",
        name: "pack",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "packTotalSupply",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "source",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amountsPacked",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "_ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_packId",
        type: "uint256",
      },
    ],
    name: "openPack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "packs",
    outputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "openStart",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "randomnessRequests",
    outputs: [
      {
        internalType: "uint256",
        name: "packId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "opener",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "rawFulfillRandomness",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rewards",
    outputs: [
      {
        internalType: "address",
        name: "source",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardsPerOpen",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newFees",
        type: "uint256",
      },
    ],
    name: "setChainlinkFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_restrictedTransfer",
        type: "bool",
      },
    ],
    name: "setRestrictedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    name: "setRoyaltyBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "transferERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transfersRestricted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vrfFees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vrfKeyHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type PackConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PackConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Pack__factory extends ContractFactory {
  constructor(...args: PackConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    _uri: string,
    _vrfCoordinator: string,
    _linkToken: string,
    _keyHash: BytesLike,
    _fees: BigNumberish,
    _trustedForwarder: string,
    _royaltyBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Pack> {
    return super.deploy(
      _controlCenter,
      _uri,
      _vrfCoordinator,
      _linkToken,
      _keyHash,
      _fees,
      _trustedForwarder,
      _royaltyBps,
      overrides || {}
    ) as Promise<Pack>;
  }
  getDeployTransaction(
    _controlCenter: string,
    _uri: string,
    _vrfCoordinator: string,
    _linkToken: string,
    _keyHash: BytesLike,
    _fees: BigNumberish,
    _trustedForwarder: string,
    _royaltyBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenter,
      _uri,
      _vrfCoordinator,
      _linkToken,
      _keyHash,
      _fees,
      _trustedForwarder,
      _royaltyBps,
      overrides || {}
    );
  }
  attach(address: string): Pack {
    return super.attach(address) as Pack;
  }
  connect(signer: Signer): Pack__factory {
    return super.connect(signer) as Pack__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PackInterface {
    return new utils.Interface(_abi) as PackInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Pack {
    return new Contract(address, _abi, signerOrProvider) as Pack;
  }
}
